import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import { cn } from '@module/lib/utils';
import type React from 'react';
import type { HTMLProps } from 'react';
interface GraySearchInputProps extends HTMLProps<HTMLInputElement> {
  setValue?: (value: string) => void;
  placeholder?: string;
  onSearch: (event: React.FormEvent<HTMLFormElement>) => void;
}
function GraySearchInput(t0) {
  const $ = _c(25);
  let className;
  let onSearch;
  let placeholder;
  let props;
  let setValue;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      setValue,
      placeholder,
      onSearch,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onSearch;
    $[3] = placeholder;
    $[4] = props;
    $[5] = setValue;
    $[6] = value;
  } else {
    className = $[1];
    onSearch = $[2];
    placeholder = $[3];
    props = $[4];
    setValue = $[5];
    value = $[6];
  }
  let t1;
  if ($[7] !== className) {
    t1 = cn("flex items-center space-x-3 rounded-[8px] bg-colorBg09 px-4 py-[10px] text-sm", className);
    $[7] = className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== setValue) {
    t2 = e => {
      if (setValue) {
        setValue(e.target.value);
      }
    };
    $[9] = setValue;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== placeholder || $[12] !== props || $[13] !== t2 || $[14] !== value) {
    t3 = <input type="text" value={value} onChange={t2} placeholder={placeholder} className="flex-1 rounded-l-md border-none bg-transparent pr-[20px] text-colorFg20 placeholder:text-colorFg14 focus:outline-none focus:ring-0" {...props} />;
    $[11] = placeholder;
    $[12] = props;
    $[13] = t2;
    $[14] = value;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== setValue || $[17] !== value) {
    t4 = value && String(value).length > 0 && <button type="button" onClick={() => {
      if (setValue) {
        setValue("");
      }
    }} className="flex h-4 w-4 items-center justify-center rounded-full bg-zinc-400 text-lg text-white focus:outline-none">×</button>;
    $[16] = setValue;
    $[17] = value;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <button type="submit"><img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/search_gray.png`} alt="search" width={14} /></button>;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== onSearch || $[21] !== t1 || $[22] !== t3 || $[23] !== t4) {
    t6 = <form onSubmit={onSearch} className={t1}>{t3}{t4}{t5}</form>;
    $[20] = onSearch;
    $[21] = t1;
    $[22] = t3;
    $[23] = t4;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}
export default GraySearchInput;